(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  var LS_CLONED = 'clonedVoices';
  var LS_VOICE_PREFIX = 'voiceForCharacter:';
  var recorder = null;
  var recordedChunks = [];
  var recordTimer = null;
  var pendingSampleFile = null;

  function readCloned() {
    try {
      var parsed = JSON.parse(localStorage.getItem(LS_CLONED) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeCloned(list) {
    try {
      localStorage.setItem(LS_CLONED, JSON.stringify(list));
    } catch (error) {}
  }

  function loadSharedClones() {
    if (!window.userData?.id) return;
    var auth = typeof window.getAuthCredentials === 'function' ? window.getAuthCredentials() : window.userData;
    if (!auth || !auth.secret) return;
    fetch('/api/voice-clones', { credentials: 'include' }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.voices)) return;
      var local = readCloned();
      var merged = data.voices.map(function (voice) {
        var old = local.find(function (item) { return item.id === voice.id; }) || {};
        return { id: voice.id, name: voice.name, refUrl: voice.ref_url, previewUrl: voice.preview_url || old.previewUrl || '', created: voice.created_at };
      });
      writeCloned(merged);
      var list = document.getElementById('vs-cloned-list');
      if (list) renderClonedList(list);
    }).catch(function () {});
  }

  function currentCharacterName() {
    var el = document.querySelector('.chat-one-to-one-name, .chat-group-name');
    var name = el ? (el.textContent || '').trim() : '';
    if (!name) {
      var path = window.location.pathname || '';
      var match = path.match(/\/(?:ai|chat)\/([^/]+)/);
      name = match ? decodeURIComponent(match[1]) : '';
    }
    return name;
  }

  function getPreferredVoice() {
    try {
      return localStorage.getItem('preferredVoice') || 'af_nicole';
    } catch (error) {
      return 'af_nicole';
    }
  }

  function applyVoice(voice) {
    if (typeof window.setVoice === 'function') {
      window.setVoice(voice);
    }
    var character = currentCharacterName();
    if (character) {
      try {
        localStorage.setItem(LS_VOICE_PREFIX + character, voice);
      } catch (error) {}
    }
  }

  function restoreCharacterVoice() {
    var character = currentCharacterName();
    if (!character) {
      return;
    }
    var saved = null;
    try {
      saved = localStorage.getItem(LS_VOICE_PREFIX + character);
    } catch (error) {}
    if (saved && typeof window.setVoice === 'function') {
      window.setVoice(saved);
    }
  }

  function injectStyles() {
    if (document.getElementById('voices-sidebar-styles')) {
      return;
    }
    var style = document.createElement('style');
    style.id = 'voices-sidebar-styles';
    style.textContent = [
      '#voices-sidebar{width:min(1080px,calc(100vw - 32px));max-width:none;max-height:min(760px,calc(100dvh - 32px));box-sizing:border-box;padding:0;border:0;border-radius:18px;background:#f5f5f3;color:#202124;box-shadow:0 24px 80px rgba(0,0,0,.45);font:14px Arial,sans-serif;overflow:hidden;}',
      '#voices-sidebar::backdrop{background:rgba(10,12,16,.7);backdrop-filter:blur(3px);}',
      '#voices-sidebar .vs-header{display:flex;align-items:center;justify-content:space-between;padding:20px 24px;border-bottom:1px solid #deded9;background:#fff;}',
      '#voices-sidebar .vs-header h3{margin:0;font-size:23px;font-weight:700;}',
      '#voices-sidebar .vs-header p{margin:4px 0 0;color:#70736f;font-size:13px;}',
      '#voices-sidebar .vs-body{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:16px;max-height:calc(100dvh - 132px);padding:18px;overflow:auto;}',
      '#voices-sidebar .vs-panel{min-width:0;padding:20px;border:1px solid #deded9;border-radius:14px;background:#fff;}',
      '#voices-sidebar .vs-panel h4{margin:0;font-size:18px;font-weight:700;}',
      '#voices-sidebar .vs-panel-intro{min-height:38px;margin:6px 0 18px;color:#70736f;font-size:13px;line-height:1.45;}',
      '#voices-sidebar .vs-field{display:grid;gap:6px;margin:0 0 14px;}',
      '#voices-sidebar .vs-field>label{font-size:12px;font-weight:700;color:#555b58;}',
      '#voices-sidebar select,#voices-sidebar input[type=text]{width:100%;min-height:44px;box-sizing:border-box;padding:0 12px;border:1px solid #c9cbc7;border-radius:8px;background:#fff;color:#202124;font:14px Arial,sans-serif;}',
      '#voices-sidebar select:focus,#voices-sidebar input:focus{outline:0;border-color:#d6863f;box-shadow:0 0 0 3px rgba(214,134,63,.16);}',
      '#voices-sidebar .vs-row{display:flex;gap:8px;align-items:center;margin:10px 0;}',
      '#voices-sidebar .vs-btn{min-height:40px;padding:0 13px;border:1px solid #c9cbc7;border-radius:8px;background:#fff;color:#30332f;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;gap:6px;font:600 13px Arial,sans-serif;}',
      '#voices-sidebar .vs-btn:hover{background:#f0f0ed;}',
      '#voices-sidebar .vs-btn--primary{background:#d6863f;border-color:#d6863f;color:#fff;}',
      '#voices-sidebar .vs-btn--primary:hover{filter:brightness(1.06);background:#d6863f;}',
      '#voices-sidebar .vs-btn--wide{width:100%;min-height:48px;font-size:14px;}',
      '#voices-sidebar .vs-btn.recording{background:#a63c36;border-color:#a63c36;color:#fff;}',
      '#voices-sidebar .vs-note{font-size:12px;color:#747873;line-height:1.45;margin:7px 0;}',
      '#voices-sidebar .vs-settings{margin-top:18px;padding-top:16px;border-top:1px solid #e4e4df;}',
      '#voices-sidebar .vs-settings summary{cursor:pointer;font-size:13px;font-weight:700;color:#555b58;}',
      '#voices-sidebar .vs-clone-form{margin:12px 0 16px;padding:14px;border:1px solid #e2c39f;border-radius:10px;background:#fffaf4;}',
      '#voices-sidebar .vs-clone-form[hidden]{display:none;}',
      '#voices-sidebar .vs-clone-item{display:grid;grid-template-columns:minmax(0,1fr) auto auto;align-items:center;gap:6px;padding:10px 8px 10px 12px;border:1px solid #deded9;border-radius:9px;margin:7px 0;}',
      '#voices-sidebar .vs-clone-item.active{border-color:#d6863f;background:#fff8ef;}',
      '#voices-sidebar .vs-clone-item button{width:34px;height:34px;border:0;border-radius:50%;background:transparent;color:#6c706b;cursor:pointer;padding:0;display:grid;place-items:center;}',
      '#voices-sidebar .vs-clone-item button:hover{background:#ededE8;color:#202124;}',
      '#voices-sidebar .vs-clone-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:600;}',
      '#voices-sidebar .material-icons{font-size:19px;}',
      '#voices-sidebar label.vs-switch{display:flex;align-items:center;gap:8px;cursor:pointer;margin:12px 0;}',
      '#voices-sidebar audio{width:100%;margin-top:8px;}',
      '#voices-sidebar .vs-current{display:flex;align-items:center;gap:8px;width:100%;min-height:44px;margin:6px 0 16px;padding:0 12px;border:0;border-radius:8px;background:#f1f1ed;color:#30332f;cursor:pointer;font:inherit;font-weight:600;text-align:left;}',
      '#voices-sidebar .vs-current:hover{background:#e7e7e2;}#voices-sidebar .vs-current:focus-visible{outline:2px solid #d6863f;outline-offset:2px;}',
      '#voices-sidebar .vs-current-name{margin-left:auto;font-weight:400;color:#6c706b;}',
      '#voices-sidebar .vs-current .material-icons{color:#d6863f;}',
      '#voices-sidebar .vs-search-results{display:grid;gap:6px;max-height:190px;overflow:auto;margin:-6px 0 14px;}',
      '#voices-sidebar .vs-search-result{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px;align-items:center;padding:9px 10px;border:1px solid #deded9;border-radius:8px;background:#fff;text-align:left;cursor:pointer;}',
      '#voices-sidebar .vs-search-result:hover{border-color:#d6863f;background:#fff8ef;}#voices-sidebar .vs-search-result small{color:#70736f;}',
      '#voices-sidebar .vs-close{width:40px;min-width:40px;padding:0;border:0;border-radius:50%;background:#f0f0ed;}',
      '@media(max-width:760px){#voices-sidebar{width:calc(100vw - 12px);height:calc(100dvh - 12px);max-height:none;border-radius:14px;}#voices-sidebar .vs-header{padding:15px 16px;}#voices-sidebar .vs-header h3{font-size:20px;}#voices-sidebar .vs-body{grid-template-columns:1fr;max-height:calc(100dvh - 84px);padding:10px;}}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function voiceOptionGroups() {
    var catalog = window.NETWRCK_VOICE_CATALOG || { kokoro: [], supertonic: [], labels: {} };
    var groups = [];
    var cloned = readCloned();
    if (cloned.length) {
      groups.push({
        label: 'My Cloned Voices (uses credits)',
        options: cloned.map(function (voice) {
          return { value: 'clone:' + voice.id, label: voice.name };
        }),
      });
    }
    groups.push({
      label: 'Local Fast (Kokoro, on-device)',
      options: (catalog.kokoro || []).map(function (id) {
        return { value: id, label: catalog.labels[id] || id };
      }),
    });
    groups.push({
      label: 'Supertonic (server, multilingual)',
      options: (catalog.supertonic || []).map(function (id) {
        return { value: id, label: catalog.labels[id] || id };
      }),
    });
    var browserVoices =
      window.speechSynthesis && typeof window.speechSynthesis.getVoices === 'function'
        ? window.speechSynthesis.getVoices() || []
        : [];
    if (browserVoices.length) {
      groups.push({
        label: 'Browser Voices (offline)',
        options: browserVoices.slice(0, 40).map(function (voice) {
          return { value: voice.name, label: voice.name + ' (' + voice.lang + ')' };
        }),
      });
    }
    return groups;
  }

  function renderVoiceSelectors(root) {
    var current = getPreferredVoice();
    var groups = voiceOptionGroups().filter(function (group) {
      return group.options.length;
    });
    var modelSelect = root.querySelector('#vs-model-select');
    var voiceSelect = root.querySelector('#vs-voice-select');
    var currentLine = root.querySelector('#vs-current-voice');
    var selectedGroup = 0;
    groups.some(function (group, index) {
      if (group.options.some(function (option) { return option.value === current; })) {
        selectedGroup = index;
        return true;
      }
      return false;
    });
    modelSelect.innerHTML = '';
    groups.forEach(function (group, index) {
      var option = document.createElement('option');
      option.value = String(index);
      option.textContent = group.label;
      modelSelect.appendChild(option);
    });
    modelSelect.value = String(selectedGroup);

    function fillVoices(groupIndex, useCurrent) {
      var group = groups[groupIndex];
      voiceSelect.innerHTML = '';
      if (!group) {
        currentLine.textContent = 'No voices available';
        return;
      }
      group.options.forEach(function (item) {
        var option = document.createElement('option');
        option.value = item.value;
        option.textContent = item.label;
        voiceSelect.appendChild(option);
      });
      if (useCurrent && group.options.some(function (item) { return item.value === current; })) {
        voiceSelect.value = current;
      }
      var selected = group.options.find(function (item) { return item.value === voiceSelect.value; });
      currentLine.textContent = selected ? selected.label : 'No voice selected';
    }

    fillVoices(selectedGroup, true);
    modelSelect.onchange = function () {
      fillVoices(parseInt(modelSelect.value, 10), false);
      if (voiceSelect.value) {
        applyVoice(voiceSelect.value);
        refreshUI();
      }
    };
    voiceSelect.onchange = function () {
      applyVoice(voiceSelect.value);
      refreshUI();
    };
  }

  function bindPresetSearch(root) {
    var input = root.querySelector('#vs-preset-search');
    var results = root.querySelector('#vs-preset-results');
    var timer = null;
    function searchPresets() {
      var query = (input.value || '').trim();
      fetch('/api/search-audio?' + new URLSearchParams({ query: query, kind: 'voice', limit: '80' }))
        .then(function (response) { if (!response.ok) throw new Error('voice search failed'); return response.json(); })
        .then(function (voices) {
          results.innerHTML = '';
          (Array.isArray(voices) ? voices : []).filter(function (voice) {
            return voice.provider === 'kokoro' || voice.provider === 'supertonic';
          }).slice(0, 20).forEach(function (voice) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'vs-search-result';
            var value = voice.provider_id;
            button.innerHTML = '<span>' + escapeVoiceText(voice.title || value) + '<br><small>' + escapeVoiceText((voice.description || '').slice(0, 90)) + '</small></span><span class="material-icons">check</span>';
            button.addEventListener('click', function () {
              applyVoice(value);
              input.value = voice.title || value;
              results.innerHTML = '';
              refreshUI();
            });
            results.appendChild(button);
          });
        })
        .catch(function () { results.innerHTML = ''; });
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(searchPresets, 180);
    });
  }

  function escapeVoiceText(value) {
    var span = document.createElement('span');
    span.textContent = String(value || '');
    return span.innerHTML;
  }

  function renderClonedList(container) {
    container.innerHTML = '';
    var cloned = readCloned();
    var current = getPreferredVoice();
    if (!cloned.length) {
      var empty = document.createElement('div');
      empty.className = 'vs-note';
      empty.textContent = 'No cloned voices yet. Record or upload a 5-10s sample below.';
      container.appendChild(empty);
      return;
    }
    cloned.forEach(function (voice) {
      var item = document.createElement('div');
      item.className = 'vs-clone-item' + (current === 'clone:' + voice.id ? ' active' : '');
      var name = document.createElement('span');
      name.className = 'vs-clone-name';
      name.textContent = voice.name;
      name.style.cursor = 'pointer';
      name.style.flex = '1';
      name.title = 'Use this voice';
      name.addEventListener('click', function () {
        applyVoice('clone:' + voice.id);
        refreshUI();
      });
      var test = document.createElement('button');
      test.innerHTML = '<span class="material-icons">play_arrow</span>';
      test.title = 'Test voice';
      test.addEventListener('click', function () {
        var prev = getPreferredVoice();
        applyVoice('clone:' + voice.id);
        if (prev !== 'clone:' + voice.id) {
          refreshUI();
        }
        if (voice.previewUrl && typeof window.playVoicePreview === 'function') {
          window.playVoicePreview('clone:' + voice.id).then(function (played) {
            if (!played && typeof window.speakMessageText === 'function') {
              window.speakMessageText('Hi, this is my cloned voice speaking.');
            }
          });
          return;
        }
        if (typeof window.speakMessageText === 'function') {
          window.speakMessageText('Hi, this is my cloned voice speaking.');
        }
      });
      var del = document.createElement('button');
      del.innerHTML = '<span class="material-icons">delete</span>';
      del.title = 'Delete voice';
      del.addEventListener('click', function () {
        writeCloned(readCloned().filter(function (v) {
          return v.id !== voice.id;
        }));
        if (getPreferredVoice() === 'clone:' + voice.id) {
          applyVoice('F4');
        }
        refreshUI();
      });
      item.appendChild(name);
      item.appendChild(test);
      item.appendChild(del);
      container.appendChild(item);
    });
  }

  function getSignedUploadUrl(contentType, fileName) {
    return fetch(
      '/file-upload-get-signed-url-cloudflare?' +
        new URLSearchParams({ file_type: contentType, file_name: fileName }),
      { method: 'GET', headers: { 'Content-Type': 'application/json' } }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error('signed url failed: ' + response.status);
      }
      return response.json();
    });
  }

  function uploadSample(file) {
    var name = 'voice-sample-' + Date.now() + '.wav';
    return getSignedUploadUrl(file.type || 'audio/wav', name).then(function (signed) {
      return fetch(signed.url, {
        method: 'PUT',
        headers: { 'Content-Type': file.type || 'audio/wav' },
        body: file,
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('sample upload failed: ' + response.status);
        }
        var bucket = signed.bucket_name || 'netwrckstatic.netwrck.com';
        return 'https://' + bucket + '/' + signed.object_path;
      });
    });
  }

  function stopRecording(recordButton) {
    if (recorder && recorder.state !== 'inactive') {
      recorder.stop();
      recorder.stream.getTracks().forEach(function (track) {
        track.stop();
      });
    }
    if (recordTimer) {
      clearTimeout(recordTimer);
      recordTimer = null;
    }
    recordButton.classList.remove('recording');
    recordButton.innerHTML = '<span class="material-icons">mic</span> Record';
  }

  function bindCloneControls(root) {
    var recordButton = root.querySelector('#vs-record-btn');
    var uploadInput = root.querySelector('#vs-upload-input');
    var uploadButton = root.querySelector('#vs-upload-btn');
    var preview = root.querySelector('#vs-sample-preview');
    var nameInput = root.querySelector('#vs-clone-name');
    var saveButton = root.querySelector('#vs-save-clone-btn');
    var status = root.querySelector('#vs-clone-status');
    var newCloneButton = root.querySelector('#vs-new-clone-btn');
    var cloneForm = root.querySelector('#vs-clone-form');

    newCloneButton.addEventListener('click', function () {
      cloneForm.hidden = !cloneForm.hidden;
      newCloneButton.setAttribute('aria-expanded', cloneForm.hidden ? 'false' : 'true');
      newCloneButton.innerHTML = cloneForm.hidden
        ? '<span class="material-icons">add</span> Create a new voice clone'
        : '<span class="material-icons">close</span> Close voice clone form';
      if (!cloneForm.hidden) {
        nameInput.focus();
      }
    });

    function setSample(file) {
      pendingSampleFile = file;
      preview.src = URL.createObjectURL(file);
      preview.style.display = 'block';
      status.textContent = 'Sample ready. Name it and save.';
    }

    recordButton.addEventListener('click', function () {
      if (recorder && recorder.state === 'recording') {
        stopRecording(recordButton);
        return;
      }
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(function (stream) {
          recordedChunks = [];
          recorder = new MediaRecorder(stream);
          recorder.ondataavailable = function (event) {
            recordedChunks.push(event.data);
          };
          recorder.onstop = function () {
            var blob = new Blob(recordedChunks, { type: 'audio/wav' });
            setSample(new File([blob], 'recorded-voice.wav', { type: 'audio/wav' }));
          };
          recorder.start();
          recordButton.classList.add('recording');
          recordButton.innerHTML = '<span class="material-icons">stop</span> Stop';
          recordTimer = setTimeout(function () {
            stopRecording(recordButton);
          }, 10000);
        })
        .catch(function (error) {
          console.error('mic access failed:', error);
          status.textContent = 'Microphone unavailable. Check permissions.';
        });
    });

    uploadButton.addEventListener('click', function () {
      uploadInput.click();
    });
    uploadInput.addEventListener('change', function (event) {
      var file = event.target.files && event.target.files[0];
      if (file) {
        setSample(file);
      }
    });

    saveButton.addEventListener('click', function () {
      var name = (nameInput.value || '').trim();
      if (!pendingSampleFile) {
        status.textContent = 'Record or upload a sample first.';
        return;
      }
      if (!name) {
        status.textContent = 'Give your voice a name.';
        return;
      }
      status.textContent = 'Uploading sample…';
      saveButton.disabled = true;
      uploadSample(pendingSampleFile)
        .then(function (refUrl) {
          var list = readCloned();
          var id = 'v' + Date.now().toString(36);
          list.push({ id: id, name: name, refUrl: refUrl, created: Date.now() });
          writeCloned(list);
          return fetch('/api/voice-clones', { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, name: name, ref_url: refUrl }) })
            .then(function (response) { if (!response.ok) throw new Error('voice save failed'); return response.json(); })
            .then(function (serverVoice) {
              list[list.length - 1].id = serverVoice.id;
              writeCloned(list);
              pendingSampleFile = null;
              nameInput.value = '';
              preview.style.display = 'none';
              status.textContent = 'Saved. Preview generates on first play.';
              saveButton.disabled = false;
              applyVoice('clone:' + serverVoice.id);
              cloneForm.hidden = true;
              newCloneButton.setAttribute('aria-expanded', 'false');
              newCloneButton.innerHTML = '<span class="material-icons">add</span> Create a new voice clone';
              refreshUI();
            });
        })
        .catch(function (error) {
          console.error('voice clone save failed:', error);
          status.textContent = 'Upload failed. Sign in and try again.';
          saveButton.disabled = false;
        });
    });
  }

  function buildSidebar() {
    var sidebar = document.createElement('dialog');
    sidebar.id = 'voices-sidebar';
    sidebar.className = 'mdl-dialog';
    sidebar.setAttribute('aria-label', 'Voice settings');
    sidebar.innerHTML = [
      '<header class="vs-header">',
      '<div><h3>Voice Studio</h3><p>Choose how chat messages sound or create a reusable voice clone.</p></div>',
      '<button type="button" class="vs-btn vs-close" id="vs-close-btn" aria-label="Close Voice Studio"><span class="material-icons">close</span></button>',
      '</header>',
      '<div class="vs-body">',
      '<section class="vs-panel">',
      '<h4>Text voice</h4>',
      '<p class="vs-panel-intro">Select the model and voice used when chat messages are read aloud.</p>',
      '<div class="vs-field"><label for="vs-preset-search">Search preset voices</label><input type="text" id="vs-preset-search" placeholder="e.g. British ASMR narrator" autocomplete="off"></div>',
      '<div class="vs-search-results" id="vs-preset-results"></div>',
      '<div class="vs-field"><label for="vs-model-select">Voice model</label><select id="vs-model-select"></select></div>',
      '<div class="vs-field"><label for="vs-voice-select">Voice</label><select id="vs-voice-select"></select></div>',
      '<button type="button" class="vs-current" id="vs-current-preview"><span class="material-icons">play_arrow</span><span>Play preview voice</span><span class="vs-current-name" id="vs-current-voice"></span></button>',
      '<div class="vs-note" id="vs-preview-note">Preview samples are pre-recorded and free.</div>',
      '<div class="vs-field"><label for="vs-preview-text">Text to say</label><input type="text" id="vs-preview-text" placeholder="Type what this voice should say" maxlength="200"></div>',
      '<button type="button" class="vs-btn vs-btn--primary vs-btn--wide" id="vs-preview-btn"><span class="material-icons">graphic_eq</span> Generate speech (uses credits)</button>',
      '<details class="vs-settings"><summary>Playback settings</summary>',
      '<div class="vs-row"><label style="display:flex;align-items:center;gap:8px;width:100%;">Speed <input type="range" id="vs-speed" min="0.5" max="2" step="0.1" style="flex:1;"><span id="vs-speed-value">1.0x</span></label></div>',
      '<label class="vs-switch"><input type="checkbox" id="vs-supertonic-local"> Run Supertonic on-device</label>',
      '<div class="vs-note" id="vs-supertonic-local-note">Downloads models once, then runs in your browser. Turn off to use the server.</div>',
      '</details>',
      '<div class="vs-note" id="vs-character-note"></div>',
      '</section>',
      '<section class="vs-panel">',
      '<h4>Voice clones</h4>',
      '<p class="vs-panel-intro">Add a clean recording, name it, then use that voice in any chat.</p>',
      '<button type="button" class="vs-btn vs-btn--primary vs-btn--wide" id="vs-new-clone-btn" aria-expanded="false"><span class="material-icons">add</span> Create a new voice clone</button>',
      '<div class="vs-clone-form" id="vs-clone-form" hidden>',
      '<div class="vs-field"><label for="vs-clone-name">Voice name</label><input type="text" id="vs-clone-name" placeholder="e.g. My narrator" maxlength="40"></div>',
      '<div class="vs-row">',
      '<button type="button" class="vs-btn" id="vs-record-btn"><span class="material-icons">mic</span> Record 10s</button>',
      '<button type="button" class="vs-btn" id="vs-upload-btn"><span class="material-icons">upload</span> Upload sample</button>',
      '<input type="file" id="vs-upload-input" accept="audio/*" style="display:none;">',
      '</div>',
      '<audio id="vs-sample-preview" controls style="display:none;"></audio>',
      '<div class="vs-note" id="vs-clone-status">5-10s clean sample works best. Cloned speech costs credits.</div>',
      '<button type="button" class="vs-btn vs-btn--primary vs-btn--wide" id="vs-save-clone-btn"><span class="material-icons">save</span> Save voice clone</button>',
      '</div>',
      '<div class="vs-note" style="margin-top:18px;font-weight:700;">My voice clones</div>',
      '<div id="vs-cloned-list"></div>',
      '</section>',
      '</div>',
    ].join('');
    document.body.appendChild(sidebar);

    sidebar.querySelector('#vs-close-btn').addEventListener('click', function () {
      sidebar.close();
    });
    sidebar.addEventListener('close', function () {
      sidebar.classList.remove('open');
      if (typeof window.resetAudioPlayback === 'function') {
        window.resetAudioPlayback();
      }
    });

    var previewNote = sidebar.querySelector('#vs-preview-note');
    var generateButton = sidebar.querySelector('#vs-preview-btn');
    var generateBusy = false;

    function playPreviewSample() {
      if (typeof window.playVoicePreview !== 'function') {
        return;
      }
      var voice = getPreferredVoice();
      previewNote.textContent = 'Loading preview…';
      window.playVoicePreview(voice).then(function (played) {
        if (played) {
          previewNote.textContent = 'Preview samples are pre-recorded and free.';
          return;
        }
        var catalog = window.NETWRCK_VOICE_CATALOG || {};
        var hosted =
          (catalog.kokoro || []).indexOf(voice) !== -1 ||
          (catalog.supertonic || []).indexOf(voice) !== -1 ||
          voice.indexOf('clone:') === 0;
        if (!hosted && typeof window.speakMessageText === 'function') {
          previewNote.textContent = 'Playing this browser voice locally.';
          window.speakMessageText('Hi, this is a voice preview.');
          return;
        }
        previewNote.textContent = 'No preview recorded for this voice yet. Type text below to generate one.';
      });
    }

    function generateSpeech() {
      var input = sidebar.querySelector('#vs-preview-text');
      var text = (input.value || '').trim();
      if (!text) {
        previewNote.textContent = 'Type the text you want spoken first.';
        input.focus();
        return;
      }
      if (generateBusy || typeof window.speakMessageText !== 'function') {
        return;
      }
      generateBusy = true;
      generateButton.disabled = true;
      previewNote.textContent = 'Generating speech…';
      var done = function (message) {
        generateBusy = false;
        generateButton.disabled = false;
        previewNote.textContent = message;
      };
      try {
        var result = window.speakMessageText(text);
        if (result && typeof result.then === 'function') {
          result.then(
            function () { done('Speaking. Generated speech uses credits.'); },
            function () { done('Speech generation failed. Try again or pick another voice.'); }
          );
        } else {
          done('Speaking. Generated speech uses credits.');
        }
      } catch (error) {
        done('Speech generation failed.');
      }
    }

    sidebar.querySelector('#vs-current-preview').addEventListener('click', playPreviewSample);
    generateButton.addEventListener('click', generateSpeech);
    sidebar.querySelector('#vs-preview-text').addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        generateSpeech();
      }
    });

    var speed = sidebar.querySelector('#vs-speed');
    var speedValue = sidebar.querySelector('#vs-speed-value');
    var savedSpeed = '1.0';
    try {
      savedSpeed = localStorage.getItem('speechSpeed') || '1.0';
    } catch (error) {}
    speed.value = savedSpeed;
    speedValue.textContent = parseFloat(savedSpeed).toFixed(1) + 'x';
    speed.addEventListener('input', function () {
      speedValue.textContent = parseFloat(speed.value).toFixed(1) + 'x';
      try {
        localStorage.setItem('speechSpeed', speed.value);
      } catch (error) {}
    });

    var stLocal = sidebar.querySelector('#vs-supertonic-local');
    if (stLocal) {
      var stEnabled = true;
      try {
        stEnabled = localStorage.getItem('supertonicLocalEnabled') !== 'false';
      } catch (error) {}
      stLocal.checked = stEnabled;
      stLocal.addEventListener('change', function () {
        try {
          localStorage.setItem('supertonicLocalEnabled', stLocal.checked ? 'true' : 'false');
        } catch (error) {}
        if (stLocal.checked && typeof window.supertonicWarmup === 'function') {
          window.supertonicWarmup();
          var note = sidebar.querySelector('#vs-supertonic-local-note');
          if (note) {
            note.textContent = 'Downloading Supertonic models (~400MB) once; first line may use the server until ready.';
          }
        }
      });
    }

    bindCloneControls(sidebar);
    bindPresetSearch(sidebar);
    return sidebar;
  }

  function openSidebar() {
    var sidebar = document.getElementById('voices-sidebar');
    if (!sidebar) {
      return;
    }
    if (!sidebar.open && typeof sidebar.showModal === 'function') {
      sidebar.showModal();
    } else if (!sidebar.open) {
      sidebar.setAttribute('open', '');
    }
    sidebar.classList.add('open');
    refreshUI();
    if (typeof window.kokoroWarmup === 'function') {
      window.kokoroWarmup();
    }
  }

  function refreshUI() {
    var sidebar = document.getElementById('voices-sidebar');
    if (!sidebar) {
      return;
    }
    renderVoiceSelectors(sidebar);
    renderClonedList(sidebar.querySelector('#vs-cloned-list'));
    var note = sidebar.querySelector('#vs-character-note');
    var character = currentCharacterName();
    note.textContent = character
      ? 'Saved per character: ' + character
      : 'Applies to this site on this device.';
  }

  function init() {
    if (!document.querySelector('.chat-log, #main-chatbox, textarea#main-chatbox')) {
      return;
    }
    injectStyles();
    buildSidebar();
    restoreCharacterVoice();
    refreshUI();
    loadSharedClones();
    var studioBtn = document.getElementById('voice-studio-sidebar-button');
    if (studioBtn) {
      studioBtn.addEventListener('click', function (event) {
        event.preventDefault();
        openSidebar();
      });
    }
    if (window.speechSynthesis && typeof window.speechSynthesis.addEventListener === 'function') {
      window.speechSynthesis.addEventListener('voiceschanged', function () {
        var sidebar = document.getElementById('voices-sidebar');
        if (sidebar && sidebar.open) {
          refreshUI();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.voicesSidebar = { refresh: refreshUI, open: openSidebar };
})();
